import dayjs from 'dayjs';

export const reservationDateLimiter = date => {
  // now plus certain limit
  const limit = dayjs().add(1, 'years');
  const selectedDate = dayjs(date, 'YYYY-MM-DD-hh-mm');

  if (selectedDate >= limit) {
    return true;
  } else {
    return false;
  }
};

export const isDateShown = (chosenDate, currentDateFrom) => {
  const now = dayjs('day');
  const selectedFromDate = dayjs(currentDateFrom, 'YYYY-MM-DD-HH-mm').startOf('day');
  const selectedDate = dayjs(chosenDate);

  if (selectedDate < now || selectedDate < selectedFromDate) {
    return true;
  } else {
    return false;
  }
};
export const isPastDate = (date, dateTo) => {
  // parsing the dates with dayjs.js
  // limiting users selection
  const now = dayjs().startOf('day')
  const individualDate = dayjs(date)
  const selectedDateTo = dayjs(dateTo, 'YYYY-MM-DD-hh-mm')
  // cap how far can be selectable
  const isTooFuture = reservationDateLimiter(date);

  if ((individualDate < now) || (dateTo !== '' && date > selectedDateTo) || isTooFuture) {
    return true
  } else {
    return false
  }
}
